export var EColumnDataType;
(function (EColumnDataType) {
    EColumnDataType["TEXT"] = "text";
    EColumnDataType["NUMBER"] = "number";
    EColumnDataType["IMAGE"] = "image";
    EColumnDataType["CURRENCY"] = "currency";
    EColumnDataType["DATE"] = "date";
    EColumnDataType["TIME"] = "time";
    EColumnDataType["DATETIME"] = "datetime";
    EColumnDataType["TAG"] = "tag";
    EColumnDataType["PERCENT"] = "percent";
    EColumnDataType["CUSTOM"] = "custom";
    EColumnDataType["ARRAY"] = "array";
    EColumnDataType["TEMPLATE"] = "template";
    EColumnDataType["MONTH"] = "month";
    EColumnDataType["QUARTER"] = "quarter";
    EColumnDataType["DURATION"] = "duration";
})(EColumnDataType || (EColumnDataType = {}));
